import React from "react"
import BannerComponent from "./Banner"
import bannerFactory from "./banner.factory"

export { default as BannerQuery } from "./banner.query"

export const Banner = props => {
  const { data } = props
  const componentProps = { ...props, ...bannerFactory.transform(data) }
  return <BannerComponent {...componentProps} />
}
